import { render, staticRenderFns } from "./RegistrationByInvite.vue?vue&type=template&id=da36681a&scoped=true&"
import script from "./RegistrationByInvite.vue?vue&type=script&lang=js&"
export * from "./RegistrationByInvite.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationByInvite.vue?vue&type=style&index=0&id=da36681a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da36681a",
  null
  
)

export default component.exports